function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.126 2.06936L3.119 7.52936C1.949 8.43936 1 10.3764 1 11.8454V21.4784C1 24.4944 3.457 26.9644 6.473 26.9644H21.527C24.543 26.9644 27 24.4944 27 21.4914V12.0274C27 10.4544 25.947 8.43936 24.66 7.54236L16.626 1.91336C14.806 0.63936 11.881 0.70436 10.126 2.06936Z",
    stroke: "#D1D1D1",
    style: {
      stroke: "#D1D1D1",
      stroke: "color(display-p3 0.8201 0.8201 0.8201)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 21.7645V17.8645",
    stroke: "#FCC226",
    style: {
      stroke: "#FCC226",
      stroke: "color(display-p3 0.9882 0.7608 0.1490)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d9f29238148bb16dd49b5557a74681fc.svg";
export { ForwardRef as ReactComponent };